module.exports = __webpack_public_path__ + "media/meditate-speak.b60821ca.mp3";